module.exports = __webpack_public_path__ + "static/media/logo-footer.fa1ce2a5.png";